<template>
    <modal
        :is-open="isOpen"
        :is-loading="loading"
        :disabled="loading"
        title="Удалить все изделия из заказа?"
        btn-save-title="Удалить"
        @onCloseModal="closeModal"
        @onSaveModal="confirmModal"
    >
    </modal>
</template>

<script>
import Modal from '@/components/Elements/Modal'

export default {
    name: 'ClearCartModal',
    components: { Modal },
    props: {
        isOpen: {
            type: Boolean,
            default: false
        }
    },
    data() {
        return {
            loading: false
        }
    },
    methods: {
        closeModal() {
            this.$emit('onClose')
        },
        confirmModal() {
            this.$emit('onConfirm')
        }
    }
}
</script>
